import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMount } from 'ahooks';
import { Layout } from 'antd';
import { PoweroffOutlined } from '@ant-design/icons';

import token from '../../utils/token';
import { useWxAgentConfig } from '../../hooks';
import accountInfo from '../../utils/accountInfo';

import styles from './index.module.less';
import imgAvatar from '../../assets/images/default-avatar.png';

export default function Header() {
    const nav = useNavigate();
    const wxAgentConfig = useWxAgentConfig();
    const userInfo = accountInfo.get();
    const openDataRef = useRef<any>();

    function handleLogout() {
        token.remove();
        accountInfo.remove();
        nav('/login', { replace: true });
    }

    useMount(() => {
        wxAgentConfig().then(() => {
            window.WWOpenData.bind(openDataRef.current);
        });
    });

    return (
        <Layout.Header className={`flex ${styles.header}`}>
            <div className={styles.left}>{userInfo.enterpriseName}</div>
            <div className={`flex ${styles.right}`}>
                <img src={userInfo.avatar || imgAvatar} alt="" className={styles.avatar} />
                <span className={styles.name}>
                    {userInfo.name ? (
                        userInfo.name
                    ) : (
                        <ww-open-data ref={openDataRef} type="userName" openid={userInfo.userId}></ww-open-data>
                    )}
                </span>
                <PoweroffOutlined className={styles['logout-btn']} onClick={handleLogout} />
            </div>
        </Layout.Header>
    );
}
